// components/SuccessAnimation.js
import { motion, AnimatePresence } from "framer-motion";

const SuccessAnimation = ({ show, isEditing }) => {
    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    className="absolute inset-0 flex flex-col items-center justify-center bg-[#EAEEFE] rounded-3xl px-8 py-20 sm:px-10 sm:py-24"
                >
                    <div className="text-center space-y-5 sm:space-y-6">
                        <motion.div
                            initial={{ scale: 0 }}
                            animate={{ scale: 1 }}
                            transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
                            className="mx-auto flex items-center justify-center w-20 h-20 sm:w-24 sm:h-24 bg-green-500 rounded-full shadow-xl"
                        >
                            <svg
                                className="w-10 h-10 sm:w-12 sm:h-12 text-white"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <motion.path
                                    initial={{ pathLength: 0 }}
                                    animate={{ pathLength: 1 }}
                                    transition={{ duration: 0.5, delay: 0.3 }}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="3"
                                    d="M5 13l4 4L19 7"
                                />
                            </svg>
                        </motion.div>
                        <motion.p
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ delay: 0.4 }}
                            className="text-lg sm:text-2xl font-semibold text-gray-900"
                        >
                            {isEditing ? "Vêtement modifié !" : "Vêtement ajouté !"}
                        </motion.p>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default SuccessAnimation;
